import React from 'react';
import { UtpCardSection } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../entrance-doors-constants';
import { ENTRANCE_DOORS_APARTMENT_CARD_LIST } from './entrance-doors-apartment-section-constants';
import {
  entranceDoorsApartmentSectionCard,
  entranceDoorsApartmentSectionTitle,
} from './entrance-doors-apartment-section-styles';

type EntranceDoorsUtpSectionProps = {
  onConsultationSignupBtnClick: () => void;
};

export const EntranceDoorsApartmentSection = ({
  onConsultationSignupBtnClick,
}: EntranceDoorsUtpSectionProps) => (
  <UtpCardSection
    elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
    elementText="Входные двери для квартиры"
    renderModalContent={({ modal: { content: ModalContent } = {} }, onCloseModal) => (
      ModalContent && <ModalContent
        onConsultationSignupBtnClick={() => {
          onCloseModal();
          onConsultationSignupBtnClick();
        }}
      />
    )}
    title="Входные двери для квартиры"
    utpCardList={ENTRANCE_DOORS_APARTMENT_CARD_LIST}
    titleClassName={entranceDoorsApartmentSectionTitle}
    cardClassName={entranceDoorsApartmentSectionCard}
  />
);
